import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import {
    Button,
    CircularProgress,
    InputAdornment,
    TextField,
    Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { SearchTerms } from "legacyNext/types";

import { S } from "./search.styles";
import { SearchView } from "./SearchView";

type Props = {
    loading: boolean;
    onSearchTermChange: (searchTerms: SearchTerms) => void;
};

const QUERY_PARAM_NAME = "bfe";

export const Search = (props: Props) => {
    const { loading = false, onSearchTermChange } = props;
    const searchParams = new URLSearchParams(window.location.search);
    const bfeValue = searchParams.get(QUERY_PARAM_NAME);
    const [searchBFE, setSearchBFE] = useState(bfeValue || "");

    const { t } = useTranslation();

    const updateSearchParams = (value: string) => {
        if (value) {
            searchParams.set(QUERY_PARAM_NAME, value);
        } else {
            searchParams.delete(QUERY_PARAM_NAME);
        }
        const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
        window.history.replaceState({}, "", newUrl);
    };

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setSearchBFE(value);
    };

    function onSearch() {
        onSearchTermChange({
            bfeList: searchBFE.split(","),
            epcClassificationList: [],
        });
        updateSearchParams(searchBFE);
    }

    useEffect(() => {
        if (bfeValue) {
            onSearch();
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <S.Search>
            <Typography variant="h4">
                {t("legacyNext.searchTitle", "Find properties or portfolios")}
            </Typography>
            <S.Inner>
                <S.SearchField>
                    <TextField
                        value={searchBFE}
                        onChange={handleSearchChange}
                        variant="outlined"
                        placeholder={t(
                            "legacyNext.searchPlaceholder",
                            "search for bfe"
                        )}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" && searchBFE !== "") {
                                onSearch();
                            }
                        }}
                        fullWidth
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <SearchOutlinedIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                </S.SearchField>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={onSearch}
                    disabled={searchBFE === ""}
                >
                    {loading ? (
                        <CircularProgress size={24} color="secondary" />
                    ) : (
                        t("legacyNext.searchButton", "Search")
                    )}
                </Button>
            </S.Inner>
            <SearchView />
        </S.Search>
    );
};
